import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarActions, MatSnackBarRef } from '@angular/material/snack-bar';

export enum ToasterType {
  ERROR = 'error-toaster',
  SUCCESS = 'success-toaster',
  INFO = 'info-toaster'
}

export interface IMessageData {
  message: string;
  title: string;
  type: ToasterType;
}

@Component({
  selector: 'app-message-toaster',
  imports: [
    MatSnackBarActions,
  ],
  templateUrl: './message-toaster.component.html',
  styleUrl: './message-toaster.component.scss',
})
export class MessageToasterComponent implements OnInit {
  title = '';
  message = '';
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: IMessageData) {}

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
  }
}
